import { render, staticRenderFns } from "./BTextareaLimited.vue?vue&type=template&id=6afbb2a1&scoped=true&"
import script from "./BTextareaLimited.vue?vue&type=script&lang=js&"
export * from "./BTextareaLimited.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afbb2a1",
  null
  
)

export default component.exports